import { api } from "@infrastructure/api";
const GLOBAL_CONTEXT = { orgContext: "global" };
const TENANT_CONTEXT = { orgContext: "tenant" };
export const billingRepository = {
    async listSubscriptions(params = {}) {
        const response = await api.get("/admin/global/billing/subscriptions", {
            ...GLOBAL_CONTEXT,
            params,
        });
        return (response.data ?? {
            items: [],
            pagination: { limit: params.limit ?? 25, offset: 0, total: 0 },
        });
    },
    async listPlans() {
        const response = await api.get("/admin/global/billing/plans", GLOBAL_CONTEXT);
        return response.data ?? { items: [] };
    },
    async createPlan(payload) {
        const response = await api.post("/admin/global/billing/plans", payload, GLOBAL_CONTEXT);
        return response.data ?? { items: [] };
    },
    async updatePlan(planId, payload) {
        const response = await api.patch(`/admin/global/billing/plans/${planId}`, payload, GLOBAL_CONTEXT);
        return response.data ?? { items: [] };
    },
    async createPlanPriceVersion(planId, payload) {
        const response = await api.post(`/admin/global/billing/plans/${planId}/prices`, payload, GLOBAL_CONTEXT);
        return response.data ?? { items: [] };
    },
    async syncPlanPriceToProvider(planId, priceId, payload = { reason: "Sync provider price" }) {
        const { reason, ...rest } = payload;
        const response = await api.post(`/admin/global/billing/plans/${planId}/prices/${priceId}/provider-sync`, { ...rest, reason }, GLOBAL_CONTEXT);
        return response.data;
    },
    async getPlatformSubscription(orgId) {
        const response = await api.get(`/admin/global/billing/subscriptions/${orgId}`, GLOBAL_CONTEXT);
        return response.data;
    },
    async previewCharge(orgId, payload) {
        const response = await api.post(`/admin/global/billing/subscriptions/${orgId}/charge-preview`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async syncSeats(orgId, payload = {}) {
        const response = await api.post(`/admin/global/billing/subscriptions/${orgId}/sync-seats`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async migrateToProvider(orgId, payload) {
        const response = await api.post(`/admin/global/billing/subscriptions/${orgId}/provider/migrate`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async syncProviderSubscription(orgId, payload) {
        const response = await api.post(`/admin/global/billing/subscriptions/${orgId}/provider/sync`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async syncProviderSeats(orgId, payload) {
        const response = await api.patch(`/admin/global/billing/subscriptions/${orgId}/provider/seats`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async changeProviderPlan(orgId, payload) {
        const response = await api.patch(`/admin/global/billing/subscriptions/${orgId}/provider/plan`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async cancelProviderSubscription(orgId, payload) {
        const response = await api.post(`/admin/global/billing/subscriptions/${orgId}/provider/cancel`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async updateSubscription(orgId, payload) {
        const response = await api.patch(`/admin/global/billing/subscriptions/${orgId}`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async createManualInvoice(orgId, payload) {
        const response = await api.post(`/admin/global/billing/subscriptions/${orgId}/manual-invoices`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async markInvoicePaid(invoiceId, payload) {
        const response = await api.post(`/admin/global/billing/invoices/${invoiceId}/mark-paid`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async rejectInvoiceProof(invoiceId, payload) {
        const response = await api.post(`/admin/global/billing/invoices/${invoiceId}/reject-proof`, payload, GLOBAL_CONTEXT);
        return response.data ?? { items: [] };
    },
    async voidInvoice(invoiceId, payload) {
        const response = await api.post(`/admin/global/billing/invoices/${invoiceId}/void`, payload, GLOBAL_CONTEXT);
        return response.data;
    },
    async listPlatformInvoices(orgId) {
        const response = await api.get(`/admin/global/billing/subscriptions/${orgId}/invoices`, GLOBAL_CONTEXT);
        return response.data ?? { items: [] };
    },
    async getOrganizationSummary(orgId) {
        const response = await api.get(`/organizations/${orgId}/billing-summary`, TENANT_CONTEXT);
        return response.data;
    },
    async listTenantInvoices(orgId) {
        const response = await api.get(`/organizations/${orgId}/billing/invoices`, {
            ...TENANT_CONTEXT,
        });
        return response.data ?? { items: [] };
    },
    async submitManualInvoiceProof(orgId, invoiceId, payload) {
        const response = await api.post(`/organizations/${orgId}/billing/invoices/${invoiceId}/proof`, payload, TENANT_CONTEXT);
        return response.data ?? { items: [] };
    },
    async createProviderSetupIntent(orgId, payload = {}) {
        const response = await api.post(`/organizations/${orgId}/billing/provider/setup-intent`, payload, TENANT_CONTEXT);
        return response.data;
    },
};
export default billingRepository;
